import { render, staticRenderFns } from "./ad002.vue?vue&type=template&id=ca95491a&"
import script from "./ad002.vue?vue&type=script&lang=js&"
export * from "./ad002.vue?vue&type=script&lang=js&"
import style0 from "./ad002.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports